import { useTranslation } from 'react-i18next'
import type { OrganizationAlert } from '@/shared/hooks/api/regulatoryNews'
import { cn } from '@/shared/lib/utils'
import { Badge } from '@/components/ui/badge'
import {
  formatNewsroomAlertDate,
  getNewsroomAlertTitle,
} from '../utils/newsroomAlertDisplay'

type NewsroomAlertListItemProps = {
  alert: OrganizationAlert
  isSelected: boolean
  onSelect: (alertId: string) => void
}

export function NewsroomAlertListItem({
  alert,
  isSelected,
  onSelect,
}: NewsroomAlertListItemProps) {
  const { t, i18n } = useTranslation('regulatory-alerts')
  const isUnread = alert.readAt === null
  const published = formatNewsroomAlertDate(alert.publishedAt, i18n.language)

  return (
    <li>
      <button
        type='button'
        className={cn(
          'w-full rounded border px-4 py-3 text-start transition-colors hover:bg-muted/50',
          isSelected && 'bg-muted'
        )}
        onClick={() => {
          onSelect(alert.id)
        }}
      >
        <div className='flex items-start justify-between gap-2'>
          <span className='line-clamp-2 text-sm font-medium'>
            {getNewsroomAlertTitle(alert, t('inbox.noTitle'))}
          </span>
          {isUnread ? (
            <Badge variant='default' className='shrink-0'>
              {t('inbox.unread')}
            </Badge>
          ) : null}
        </div>
        {published ? (
          <p className='mt-1 text-sm text-muted-foreground'>
            {t('inbox.published', { date: published })}
          </p>
        ) : null}
        {alert.dismissedAt ? (
          <p className='mt-1 text-xs text-muted-foreground'>
            {t('inbox.dismissed')}
          </p>
        ) : null}
      </button>
    </li>
  )
}
